const ViewHistoryIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />

      <path
        d="M14 24C16.5 19.5 20 17 24 17C28 17 31.5 19.5 34 24C31.5 28.5 28 31 24 31C20 31 16.5 28.5 14 24Z"
        fill="#1E1B6A"
      />

      <circle cx="24" cy="24" r="3" fill="white" />

      <circle cx="24" cy="24" r="1.5" fill="#1E1B6A" />
    </svg>
  );
};

export default ViewHistoryIcon;
